/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Cell, Grid, InfoLabel } from 'bold-ui'
import { OrigemRegistroInfo } from 'components/origem-label-tag/OrigemRegistroInfo'
import { turnoRecord } from 'types/enums'
import { formatDate } from 'util/date/formatDate'

import { AtividadeColetivaReuniaoModel, AtividadeColetivaSaudeModel } from '../model-atividadeColetiva'
import { getLocalAtividade } from '../utils-atividadeColetiva'

interface AtividadeColetivaInfoHeaderProps {
  atividadeColetiva: AtividadeColetivaSaudeModel | AtividadeColetivaReuniaoModel // TODO foundation #25668- criar novo tipo
  isFonteDadosPec: boolean
}

export const AtividadeColetivaInfoHeader = (props: AtividadeColetivaInfoHeaderProps) => {
  const { atividadeColetiva, isFonteDadosPec } = props
  return (
    <Grid gap={2} style={styles.section}>
      {!isFonteDadosPec && (
        <Cell size={12}>
          <OrigemRegistroInfo origem={atividadeColetiva.origem} />
        </Cell>
      )}
      <Cell size={3}>
        <InfoLabel title='Data da atividade'>{formatDate(atividadeColetiva.dataAtividade)}</InfoLabel>
      </Cell>
      <Cell size={3}>
        <InfoLabel title='Turno'>{turnoRecord[atividadeColetiva.turno]}</InfoLabel>
      </Cell>
      <Cell size={3}>
        <InfoLabel title='Nº de participantes'>{atividadeColetiva.numeroParticipantes}</InfoLabel>
      </Cell>
      {'numeroAvaliacoesAlteradas' in atividadeColetiva && (
        <Cell size={3}>
          <InfoLabel title='Nº de avaliações alteradas'>{atividadeColetiva.numeroAvaliacoesAlteradas}</InfoLabel>
        </Cell>
      )}
      <Cell size={3}>
        <InfoLabel title='Programa saúde na escola'>
          {(atividadeColetiva.atividadeEducacaoPse && atividadeColetiva.atividadeSaudePse && 'Educação, Saúde') ||
            (atividadeColetiva.atividadeEducacaoPse && 'Educação') ||
            (atividadeColetiva.atividadeSaudePse && 'Saúde')}
        </InfoLabel>
      </Cell>
      <Cell size={9} style={styles.wordBreakSection}>
        <InfoLabel title='Local da atividade'> {getLocalAtividade(atividadeColetiva)} </InfoLabel>
      </Cell>
    </Grid>
  )
}

const styles = {
  section: css`
    margin-top: 1.5rem;
  `,
  wordBreakSection: css`
    word-break: break-all;
  `,
}
